/**
 * API配置文件
 * 用于管理不同环境的API基础URL
 */

// 获取当前环境的API基础URL
const API_BASE_URL = process.env.NODE_ENV === 'development' ? '/api' : '/_gw';

// API版本
const API_VERSION = {
  V1: '/v1',
  V2: '/v2',
  V3: '/v3'
};

// API模块
const API_MODULES = {
  USER_SVC: '/user-svc',
  CMS_SVC: '/cms-svc',
  RES_SVC: '/res-svc',
  RECORD_SVC: '/record-svc',
  CHATGPT_SVC: '/chatgpt-svc',
};

export {
  API_BASE_URL,
  API_VERSION,
  API_MODULES
}; 